import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { startNewMcpChat } from '../utils/navigation';
import { useOptionalMcpChatOnboarding } from './McpChatOnboardingContext';

/** New chat button — opens onboarding modal when setup is incomplete. */
export function useStartNewMcpChat() {
  const navigate = useNavigate();
  const location = useLocation();
  const onboarding = useOptionalMcpChatOnboarding();

  return useCallback(() => {
    if (onboarding?.needsOnboarding) {
      if (!location.pathname.startsWith('/chat')) {
        navigate('/chat');
      }
      onboarding.requestOnboarding();
      return;
    }
    startNewMcpChat(navigate);
  }, [location.pathname, navigate, onboarding]);
}
